import React from "react";
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from "configs/AppConfig";

export const pageNotFoundRoute = {
  component: React.lazy(() => import("views/app-views/PageNotFound")),
};
export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(
      () => import("views/auth-views/authentication/login")
    ),
  },
  {
    key: "register",
    path: `${AUTH_PREFIX_PATH}/register`,
    component: React.lazy(
      () => import("views/auth-views/authentication/register")
    ),
  },
  {
    key: "forgot-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(
      () => import("views/auth-views/authentication/forgot-password")
    ),
  },
];

export const protectedRoutes = [
  {
    key: "dashboard.default",
    path: `${APP_PREFIX_PATH}/dashboards/default`,
    component: React.lazy(() => import("views/app-views/dashboards/")),
    permission: "view-dashboard",
  },
  {
    key: "roles",
    path: `${APP_PREFIX_PATH}/roles`,
    component: React.lazy(() => import("views/app-views/role/list")),
    permission: "view-roles",
  },
  {
    key: "users",
    path: `${APP_PREFIX_PATH}/users`,
    component: React.lazy(() => import("views/app-views/user/list")),
    permission: "view-users",
  },
  {
    key: "departments",
    path: `${APP_PREFIX_PATH}/departments`,
    component: React.lazy(() => import("views/app-views/department/list")),
    permission: "view-departments",
  },
  {
    key: "test-directory",
    path: `${APP_PREFIX_PATH}/test-directories`,
    component: React.lazy(() => import("views/app-views/test-list/list")),
    permission: "view-testDirectories",
  },
  {
    key: "panels",
    path: `${APP_PREFIX_PATH}/panels`,
    component: React.lazy(() => import("views/app-views/panels/list")),
    permission: "view-panels",
  },
  {
    key: "neworder",
    path: `${APP_PREFIX_PATH}/neworder`,
    component: React.lazy(() => import("views/app-views/neworder")),
    permission: "create-orders",
  },
  {
    key: "agencies",
    path: `${APP_PREFIX_PATH}/agencies`,
    component: React.lazy(() => import("views/app-views/agency/list")),
    permission: "view-agencies",
  },
  {
    key: "insurances",
    path: `${APP_PREFIX_PATH}/insurances`,
    component: React.lazy(() => import("views/app-views/insurance/list")),
    permission: "view-insurances",
  },
  {
    key: "branchs",
    path: `${APP_PREFIX_PATH}/branchs`,
    component: React.lazy(() => import("views/app-views/branch-look-up/list")),
    permission: "view-branchLookups",
  },
  {
    key: "orders",
    path: `${APP_PREFIX_PATH}/orders`,
    component: React.lazy(() => import("views/app-views/orders/list")),
    permission: "view-orders",
  },
  {
    key: "results",
    path: `${APP_PREFIX_PATH}/results`,
    component: React.lazy(() => import("views/app-views/results/")),
    permission: "view-results",
  },
  {
    key: "srd",
    path: `${APP_PREFIX_PATH}/srd`,
    component: React.lazy(() => import("views/app-views/srd")),
    permission: "manage-srd",
  },
  {
    key: "labreceive",
    path: `${APP_PREFIX_PATH}/lab-receive`,
    component: React.lazy(() => import("views/app-views/lab-receive")),
    permission: "manage-lab",
  },
  {
    key: "phlebotomy",
    path: `${APP_PREFIX_PATH}/phlebotomy`,
    component: React.lazy(() => import("views/app-views/phlebotomy")),
    permission: "manage-phlebotomy",
  },
  {
    key: "dss",
    path: `${APP_PREFIX_PATH}/tr`,
    component: React.lazy(() => import("views/app-views/tr")),
    permission: "view-tr",
  },
  {
    key: "tat",
    path: `${APP_PREFIX_PATH}/tat`,
    component: React.lazy(() => import("views/app-views/tat")),
    permission: "view-tr",
  },
  {
    key: "report",
    path: `${APP_PREFIX_PATH}/report`,
    component: React.lazy(() => import("views/app-views/report")),
    permission: "view-report",
  },
  {
    key: "qa",
    path: `${APP_PREFIX_PATH}/complainingandsatisfaction`,
    component: React.lazy(() => import("views/app-views/q_and_a")),
    permission: "view-q-and-a",
  },
];
